<template>
  <div class="risk_tip_w">
    <div class="tip_title font_w_bold fz20">风险提示</div>
    <div class="desc_w c_1A1A1A fz12" v-html="projectRisk">
    </div>
  </div>
</template>

<script>

export default {
  props: {
    projectRisk: {
      type: String,
      default: '暂无提示'
    },
    imagesUploadHandler: { // 自定义上传回调
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {

    }
  },
}
</script>

<style lang='scss' scoped>
.risk_tip_w {
  display: flex;
  align-items: center;
  padding: 13px 0;
  margin: 10px 0;
  background-color: rgba($color: #3084cf, $alpha: 0.1);
  border-right: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  .tip_title {
    width: 40px;
    padding: 14px 20px;
    color: #ef9a35;
    border-right: 1px solid #ef9a35;
  }
  p {
    &:first-child {
      margin: 0 0 16px 0;
    }
  }
  .desc_w {
    display: flex;
    align-items: center; /* 垂直居中 */
  }
}
</style>
